import { v6 as timeOrderedUUID } from 'uuid';
import type {
  ChatMessage,
  ExternalAIAssistantPayload,
  ExternalGuidedActionBoardEditPayload,
  ExternalGuidedDrillDimensionPayload,
  ExternalGuidedFilterPayload,
} from '@/aiAssistant/aiAssistant.types';

export const createGuidedUserMessage = (chatId: string, dialog: string): ChatMessage => ({
  role: 'user',
  dialog,
  id: timeOrderedUUID(),
  chatId,
  agentType: 'actions',
});

export const isExternalActionsPayload = (
  payload?: ExternalAIAssistantPayload,
): payload is
  | ExternalGuidedActionBoardEditPayload
  | ExternalGuidedDrillDimensionPayload
  | ExternalGuidedFilterPayload =>
  payload?.kind === 'guidedActionBoardEdit' ||
  payload?.kind === 'guidedDrillDimension' ||
  payload?.kind === 'guidedFilter';
